const priorityNumber = {
  L: 1,
  M: 2,
  H: 3,
};

export { priorityNumber };
